/* tslint:disable */
/* eslint-disable */
/**
 * Bank Backoffice Gateway, Signs
 * Partner\'s Bank Backoffice Gateway for Signs
 *
 * The version of the OpenAPI document: 5.0
 * Contact: viktor.dite@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const BankRequestedOperationV5 = {
    ACTIVATION_CHILD_APP: 'ACTIVATION_CHILD_APP',
    CREATE_PSD2_PAYMENT_ORDER: 'CREATE_PSD2_PAYMENT_ORDER',
    CREATE_PAYMENT_ORDER: 'CREATE_PAYMENT_ORDER',
    CREATE_CHILD_PAYMENT_ORDER: 'CREATE_CHILD_PAYMENT_ORDER',
    CREATE_CHALLENGE_PAYMENT_ORDER: 'CREATE_CHALLENGE_PAYMENT_ORDER',
    ACCOUNT_LIMIT_SET: 'ACCOUNT_LIMIT_SET',
    CREATE_PSD2_REGULAR_STANDING_ORDER: 'CREATE_PSD2_REGULAR_STANDING_ORDER',
    CREATE_REGULAR_STANDING_ORDER: 'CREATE_REGULAR_STANDING_ORDER',
    CREATE_SAVINGS_GOAL_STANDING_ORDER: 'CREATE_SAVINGS_GOAL_STANDING_ORDER',
    UPDATE_STANDING_ORDER: 'UPDATE_STANDING_ORDER',
    UPDATE_PSD2_STANDING_ORDER: 'UPDATE_PSD2_STANDING_ORDER',
    DELETE_STANDING_ORDER: 'DELETE_STANDING_ORDER',
    DELETE_PSD2_STANDING_ORDER: 'DELETE_PSD2_STANDING_ORDER',
    DEACTIVATE_STANDING_ORDER: 'DEACTIVATE_STANDING_ORDER',
    REACTIVATE_STANDING_ORDER: 'REACTIVATE_STANDING_ORDER',
    CREATE_DIRECT_DEBIT: 'CREATE_DIRECT_DEBIT',
    UPDATE_DIRECT_DEBIT: 'UPDATE_DIRECT_DEBIT',
    DELETE_DIRECT_DEBIT: 'DELETE_DIRECT_DEBIT',
    CREATE_POCKET_MONEY: 'CREATE_POCKET_MONEY',
    UPDATE_POCKET_MONEY: 'UPDATE_POCKET_MONEY',
    DELETE_POCKET_MONEY: 'DELETE_POCKET_MONEY',
    CREATE_SIPO: 'CREATE_SIPO',
    UPDATE_SIPO: 'UPDATE_SIPO',
    DELETE_SIPO: 'DELETE_SIPO',
    BUNDLE_CHANGE: 'BUNDLE_CHANGE',
    CREATE_PRODUCT_SAVINGS_ACCOUNT_BASIC: 'CREATE_PRODUCT_SAVINGS_ACCOUNT_BASIC',
    CREATE_PRODUCT_CURRENT_ACCOUNT_SECONDARY: 'CREATE_PRODUCT_CURRENT_ACCOUNT_SECONDARY',
    CREATE_PRODUCT_CURRENT_ACCOUNT_BASIC: 'CREATE_PRODUCT_CURRENT_ACCOUNT_BASIC',
    CREATE_PRODUCT_PROTECTED_ACCOUNT: 'CREATE_PRODUCT_PROTECTED_ACCOUNT',
    CREATE_PRODUCT_CURRENT_ACCOUNT_CHILD: 'CREATE_PRODUCT_CURRENT_ACCOUNT_CHILD',
    CREATE_PRODUCT_CURRENT_ACCOUNT_SHARED: 'CREATE_PRODUCT_CURRENT_ACCOUNT_SHARED',
    CREATE_PRODUCT_SAVINGS_ACCOUNT_SHARED: 'CREATE_PRODUCT_SAVINGS_ACCOUNT_SHARED',
    CREATE_PRODUCT_SAVINGS_ACCOUNT_CHILD: 'CREATE_PRODUCT_SAVINGS_ACCOUNT_CHILD',
    CHANGE_PRODUCT_SAVINGS_ACCOUNT_CHILD: 'CHANGE_PRODUCT_SAVINGS_ACCOUNT_CHILD',
    TERMINATE_ACCOUNT: 'TERMINATE_ACCOUNT',
    ADD_DISPONENT_TO_BANK_CHILD: 'ADD_DISPONENT_TO_BANK_CHILD',
    REMOVE_DISPONENT_FROM_BANK_CHILD: 'REMOVE_DISPONENT_FROM_BANK_CHILD',
    ACTIVATE_CARD: 'ACTIVATE_CARD',
    CARDS_ACS_AUTHENTICATION_APPROVE: 'CARDS_ACS_AUTHENTICATION_APPROVE',
    PREPARE_SDD_PAYLOAD: 'PREPARE_SDD_PAYLOAD',
    CHANGE_CUSTOM_ACCOUNT_NAME: 'CHANGE_CUSTOM_ACCOUNT_NAME',
    CHANGE_ACCOUNT_SETTINGS: 'CHANGE_ACCOUNT_SETTINGS',
    CREATE_PRODUCTS_FIP_ONBOARDING: 'CREATE_PRODUCTS_FIP_ONBOARDING',
    CREATE_TREASURY_PAYMENT: 'CREATE_TREASURY_PAYMENT',
    STAMP_APS_LOAN_DOCUMENT: 'STAMP_APS_LOAN_DOCUMENT',
    CARDS_TOKEN_INAPP_VERIFICATION: 'CARDS_TOKEN_INAPP_VERIFICATION',
    CREATE_CHILD_REGULAR_STANDING_ORDER: 'CREATE_CHILD_REGULAR_STANDING_ORDER',
    UPDATE_CHILD_REGULAR_STANDING_ORDER: 'UPDATE_CHILD_REGULAR_STANDING_ORDER',
    CREATE_CHILD_DIRECT_DEBIT: 'CREATE_CHILD_DIRECT_DEBIT',
    UPDATE_CHILD_DIRECT_DEBIT: 'UPDATE_CHILD_DIRECT_DEBIT',
    REACTIVATE_CHILD_REGULAR_STANDING_ORDER: 'REACTIVATE_CHILD_REGULAR_STANDING_ORDER',
    CHANGE_SAVINGS_ACCOUNT_BASIC_PARAMETERS: 'CHANGE_SAVINGS_ACCOUNT_BASIC_PARAMETERS',
    CHANGE_SAVINGS_ACCOUNT_CHILD_PARAMETERS: 'CHANGE_SAVINGS_ACCOUNT_CHILD_PARAMETERS',
    CHANGE_SAVINGS_ACCOUNT_SHARED_PARAMETERS: 'CHANGE_SAVINGS_ACCOUNT_SHARED_PARAMETERS',
    CREATE_MOBILITY: 'CREATE_MOBILITY',
    CREATE_PAYMENT_ORDER_FROM_FIP: 'CREATE_PAYMENT_ORDER_FROM_FIP',
    CREATE_STANDING_ORDER_FROM_FIP: 'CREATE_STANDING_ORDER_FROM_FIP',
    TERMINATE_PRODUCT_PROTECTED_ACCOUNT_4_EYES: 'TERMINATE_PRODUCT_PROTECTED_ACCOUNT_4_EYES',
    TERMINATE_PRODUCT_CURRENT_ACCOUNT_BASIC_4_EYES: 'TERMINATE_PRODUCT_CURRENT_ACCOUNT_BASIC_4_EYES',
    TERMINATE_PRODUCT_CURRENT_ACCOUNT_SECONDARY_4_EYES: 'TERMINATE_PRODUCT_CURRENT_ACCOUNT_SECONDARY_4_EYES',
    TERMINATE_PRODUCT_CURRENT_ACCOUNT_CHILD_4_EYES: 'TERMINATE_PRODUCT_CURRENT_ACCOUNT_CHILD_4_EYES',
    TERMINATE_PRODUCT_CURRENT_ACCOUNT_SHARED_4_EYES: 'TERMINATE_PRODUCT_CURRENT_ACCOUNT_SHARED_4_EYES',
    TERMINATE_PRODUCT_SAVINGS_ACCOUNT_BASIC_4_EYES: 'TERMINATE_PRODUCT_SAVINGS_ACCOUNT_BASIC_4_EYES',
    TERMINATE_PRODUCT_SAVINGS_ACCOUNT_CHILD_4_EYES: 'TERMINATE_PRODUCT_SAVINGS_ACCOUNT_CHILD_4_EYES',
    TERMINATE_PRODUCT_SAVINGS_ACCOUNT_SHARED_4_EYES: 'TERMINATE_PRODUCT_SAVINGS_ACCOUNT_SHARED_4_EYES',
    TERMINATE_PRODUCT_TERM_DEPOSIT_4_EYES: 'TERMINATE_PRODUCT_TERM_DEPOSIT_4_EYES',
    CREATE_SEPA_PAYMENT: 'CREATE_SEPA_PAYMENT',
    CREATE_ZPS_PAYMENT: 'CREATE_ZPS_PAYMENT',
    CANCEL_PAYMENT_ORDER: 'CANCEL_PAYMENT_ORDER',
    CARDS_3_DS_REQUEST: 'CARDS_3_DS_REQUEST',
    CARDS_SET_LIMIT: 'CARDS_SET_LIMIT',
    UPSERT_SWEEP: 'UPSERT_SWEEP',
    DEACTIVATE_SWEEP: 'DEACTIVATE_SWEEP',
    CREATE_ODOO_PAYMENT: 'CREATE_ODOO_PAYMENT',
    CREATE_PRODUCT_SUPERSAVINGS: 'CREATE_PRODUCT_SUPERSAVINGS',
    CHANGE_PRODUCT_SUPERSAVINGS: 'CHANGE_PRODUCT_SUPERSAVINGS',
    TERMINATE_PRODUCT_SUPERSAVINGS: 'TERMINATE_PRODUCT_SUPERSAVINGS',
    CREATE_PAYMENT_TEMPLATE: 'CREATE_PAYMENT_TEMPLATE',
    UPDATE_PAYMENT_TEMPLATE: 'UPDATE_PAYMENT_TEMPLATE',
    DELETE_PAYMENT_TEMPLATE: 'DELETE_PAYMENT_TEMPLATE',
    CREATE_EXCHANGE_ORDER: 'CREATE_EXCHANGE_ORDER',
    CHILD_ACCOUNT_TRANSITION: 'CHILD_ACCOUNT_TRANSITION',
    EA_LONGTERM_TRAVEL_INSURANCE_CREATE: 'EA_LONGTERM_TRAVEL_INSURANCE_CREATE',
    EA_LONGTERM_TRAVEL_INSURANCE_WITHDRAW: 'EA_LONGTERM_TRAVEL_INSURANCE_WITHDRAW',
    EA_LONGTERM_TRAVEL_INSURANCE_TERMINATION: 'EA_LONGTERM_TRAVEL_INSURANCE_TERMINATION',
    CREATE_PSD2_SEPA_PAYMENT: 'CREATE_PSD2_SEPA_PAYMENT',
    CREATE_PSD2_ZPS_PAYMENT: 'CREATE_PSD2_ZPS_PAYMENT',
    CREATE_CRYPTO_ACCOUNT: 'CREATE_CRYPTO_ACCOUNT',
    SELL_CRYPTO: 'SELL_CRYPTO',
    BUY_CRYPTO: 'BUY_CRYPTO',
    CREATE_TREASURY_FOREIGN_PAYMENT: 'CREATE_TREASURY_FOREIGN_PAYMENT',
    CREATE_PRODUCT_TERM_DEPOSIT: 'CREATE_PRODUCT_TERM_DEPOSIT',
    CANCEL_CONTRACT: 'CANCEL_CONTRACT'
} as const;

export type BankRequestedOperationV5 = typeof BankRequestedOperationV5[keyof typeof BankRequestedOperationV5];


/**
 * 
 * @export
 * @interface ClientV5
 */
export interface ClientV5 {
    /**
     * 
     * @type {string}
     * @memberof ClientV5
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientV5
     */
    'fullName'?: string;
}
/**
 * 
 * @export
 * @interface EyesSignatureV5
 */
export interface EyesSignatureV5 {
    /**
     * Index of signGroup the signature is in. 0 for first.
     * @type {number}
     * @memberof EyesSignatureV5
     */
    'groupIndex': number;
    /**
     * 
     * @type {SignStatusSimpleV5}
     * @memberof EyesSignatureV5
     */
    'signStatus': SignStatusSimpleV5;
    /**
     * 
     * @type {string}
     * @memberof EyesSignatureV5
     */
    'pidUuid'?: string;
}


/**
 * 
 * @export
 * @interface FourEyesOperationSearchFilterV5
 */
export interface FourEyesOperationSearchFilterV5 {
    /**
     * Must not be empty. Otherwise no results will be returned.
     * @type {Array<BankRequestedOperationV5>}
     * @memberof FourEyesOperationSearchFilterV5
     */
    'operationList': Array<BankRequestedOperationV5>;
    /**
     * Will not be used as filter when empty.
     * @type {Array<RequestedOperationStatusV5>}
     * @memberof FourEyesOperationSearchFilterV5
     */
    'operationStatusList': Array<RequestedOperationStatusV5>;
    /**
     * PidUuid of an officer that already signed/cancelled the operation. Will not be used as filter when null.
     * @type {string}
     * @memberof FourEyesOperationSearchFilterV5
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof FourEyesOperationSearchFilterV5
     */
    'pageable': PageableV1x0;
}
/**
 * 
 * @export
 * @interface FourEyesOperationSearchResultV5
 */
export interface FourEyesOperationSearchResultV5 {
    /**
     * 
     * @type {string}
     * @memberof FourEyesOperationSearchResultV5
     */
    'operationUuid': string;
    /**
     * BankRequestedOperation is unstable, string used in response instead (may be changed in the future).
     * @type {string}
     * @memberof FourEyesOperationSearchResultV5
     */
    'operation': string;
    /**
     * 
     * @type {RequestedOperationStatusV5}
     * @memberof FourEyesOperationSearchResultV5
     */
    'operationStatus': RequestedOperationStatusV5;
    /**
     * 
     * @type {Array<EyesSignatureV5>}
     * @memberof FourEyesOperationSearchResultV5
     */
    'eyesSignatureList': Array<EyesSignatureV5>;
    /**
     * 
     * @type {string}
     * @memberof FourEyesOperationSearchResultV5
     */
    'data': string;
    /**
     * 
     * @type {string}
     * @memberof FourEyesOperationSearchResultV5
     */
    'expiration': string;
    /**
     * Info from technical \"createdAt\" column - for requested operations timestamp of creation in DB, for processed operations timestamp of move to history.
     * @type {string}
     * @memberof FourEyesOperationSearchResultV5
     */
    'createdAt': string;
    /**
     * 
     * @type {ClientV5}
     * @memberof FourEyesOperationSearchResultV5
     */
    'client': ClientV5;
}


/**
 * 
 * @export
 * @interface FourEyesOperationSearchResultsV5
 */
export interface FourEyesOperationSearchResultsV5 {
    /**
     * 
     * @type {Array<FourEyesOperationSearchResultV5>}
     * @memberof FourEyesOperationSearchResultsV5
     */
    'content': Array<FourEyesOperationSearchResultV5>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof FourEyesOperationSearchResultsV5
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface OperationCancelRequestV5
 */
export interface OperationCancelRequestV5 {
    /**
     * 
     * @type {string}
     * @memberof OperationCancelRequestV5
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface OperationConfirmRequestV5
 */
export interface OperationConfirmRequestV5 {
    /**
     * 
     * @type {Array<string>}
     * @memberof OperationConfirmRequestV5
     */
    'confirmedAttachments'?: Array<string>;
}
/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV1x0
 */
export interface PageableResponseV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV1x0
 */
export interface PageableV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RequestedOperationStatusV5 = {
    CANCELED: 'CANCELED',
    CANCELLING: 'CANCELLING',
    DONE: 'DONE',
    EXPIRED: 'EXPIRED',
    EXPIRING: 'EXPIRING',
    PROCESSING: 'PROCESSING',
    REFUSED: 'REFUSED',
    WAITING_FOR_SIGN: 'WAITING_FOR_SIGN'
} as const;

export type RequestedOperationStatusV5 = typeof RequestedOperationStatusV5[keyof typeof RequestedOperationStatusV5];


/**
 * 
 * @export
 * @enum {string}
 */

export const SignStatusSimpleV5 = {
    NOT_READY: 'NOT_READY',
    READY: 'READY',
    SIGNED: 'SIGNED',
    CANCELED: 'CANCELED'
} as const;

export type SignStatusSimpleV5 = typeof SignStatusSimpleV5[keyof typeof SignStatusSimpleV5];




/**
 * SignsApi - axios parameter creator
 * @export
 */
export const SignsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * User can cancel the operation (when they have sufficient permissions).
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} operationUuid 
         * @param {OperationCancelRequestV5} operationCancelRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelV5: async (xCorrelationId: string, operationUuid: string, operationCancelRequestV5: OperationCancelRequestV5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('cancelV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'operationUuid' is not null or undefined
            assertParamExists('cancelV5', 'operationUuid', operationUuid)
            // verify required parameter 'operationCancelRequestV5' is not null or undefined
            assertParamExists('cancelV5', 'operationCancelRequestV5', operationCancelRequestV5)
            const localVarPath = `/bank-backofficegateway-signs/v5/operation/{operationUuid}/cancel`
                .replace(`{${"operationUuid"}}`, encodeURIComponent(String(operationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operationCancelRequestV5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign (\"eyes\" or standard). Used for AuthorizationMethod.FIRST_FACTOR
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} operationUuid 
         * @param {OperationConfirmRequestV5} operationConfirmRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmV5: async (xCorrelationId: string, operationUuid: string, operationConfirmRequestV5: OperationConfirmRequestV5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('confirmV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'operationUuid' is not null or undefined
            assertParamExists('confirmV5', 'operationUuid', operationUuid)
            // verify required parameter 'operationConfirmRequestV5' is not null or undefined
            assertParamExists('confirmV5', 'operationConfirmRequestV5', operationConfirmRequestV5)
            const localVarPath = `/bank-backofficegateway-signs/v5/operation/{operationUuid}/confirm`
                .replace(`{${"operationUuid"}}`, encodeURIComponent(String(operationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operationConfirmRequestV5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search four-eyes operations based on filter.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FourEyesOperationSearchFilterV5} fourEyesOperationSearchFilterV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFourEyesV5: async (xCorrelationId: string, fourEyesOperationSearchFilterV5: FourEyesOperationSearchFilterV5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('searchFourEyesV5', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'fourEyesOperationSearchFilterV5' is not null or undefined
            assertParamExists('searchFourEyesV5', 'fourEyesOperationSearchFilterV5', fourEyesOperationSearchFilterV5)
            const localVarPath = `/bank-backofficegateway-signs/v5/four-eyes-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fourEyesOperationSearchFilterV5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignsApi - functional programming interface
 * @export
 */
export const SignsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignsApiAxiosParamCreator(configuration)
    return {
        /**
         * User can cancel the operation (when they have sufficient permissions).
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} operationUuid 
         * @param {OperationCancelRequestV5} operationCancelRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelV5(xCorrelationId: string, operationUuid: string, operationCancelRequestV5: OperationCancelRequestV5, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelV5(xCorrelationId, operationUuid, operationCancelRequestV5, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sign (\"eyes\" or standard). Used for AuthorizationMethod.FIRST_FACTOR
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} operationUuid 
         * @param {OperationConfirmRequestV5} operationConfirmRequestV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmV5(xCorrelationId: string, operationUuid: string, operationConfirmRequestV5: OperationConfirmRequestV5, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmV5(xCorrelationId, operationUuid, operationConfirmRequestV5, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search four-eyes operations based on filter.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FourEyesOperationSearchFilterV5} fourEyesOperationSearchFilterV5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFourEyesV5(xCorrelationId: string, fourEyesOperationSearchFilterV5: FourEyesOperationSearchFilterV5, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FourEyesOperationSearchResultsV5>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFourEyesV5(xCorrelationId, fourEyesOperationSearchFilterV5, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SignsApi - factory interface
 * @export
 */
export const SignsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignsApiFp(configuration)
    return {
        /**
         * User can cancel the operation (when they have sufficient permissions).
         * @param {SignsApiCancelV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelV5(requestParameters: SignsApiCancelV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.cancelV5(requestParameters.xCorrelationId, requestParameters.operationUuid, requestParameters.operationCancelRequestV5, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Sign (\"eyes\" or standard). Used for AuthorizationMethod.FIRST_FACTOR
         * @param {SignsApiConfirmV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmV5(requestParameters: SignsApiConfirmV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.confirmV5(requestParameters.xCorrelationId, requestParameters.operationUuid, requestParameters.operationConfirmRequestV5, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Search four-eyes operations based on filter.
         * @param {SignsApiSearchFourEyesV5Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFourEyesV5(requestParameters: SignsApiSearchFourEyesV5Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FourEyesOperationSearchResultsV5> {
            return localVarFp.searchFourEyesV5(requestParameters.xCorrelationId, requestParameters.fourEyesOperationSearchFilterV5, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelV5 operation in SignsApi.
 * @export
 * @type SignsApiCancelV5Request
 */
export type SignsApiCancelV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof SignsApiCancelV5
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof SignsApiCancelV5
     */
    readonly operationUuid: string

    /**
     * 
     * @type {OperationCancelRequestV5}
     * @memberof SignsApiCancelV5
     */
    readonly operationCancelRequestV5: OperationCancelRequestV5
}

/**
 * Request parameters for confirmV5 operation in SignsApi.
 * @export
 * @type SignsApiConfirmV5Request
 */
export type SignsApiConfirmV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof SignsApiConfirmV5
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof SignsApiConfirmV5
     */
    readonly operationUuid: string

    /**
     * 
     * @type {OperationConfirmRequestV5}
     * @memberof SignsApiConfirmV5
     */
    readonly operationConfirmRequestV5: OperationConfirmRequestV5
}

/**
 * Request parameters for searchFourEyesV5 operation in SignsApi.
 * @export
 * @type SignsApiSearchFourEyesV5Request
 */
export type SignsApiSearchFourEyesV5Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof SignsApiSearchFourEyesV5
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {FourEyesOperationSearchFilterV5}
     * @memberof SignsApiSearchFourEyesV5
     */
    readonly fourEyesOperationSearchFilterV5: FourEyesOperationSearchFilterV5
}

/**
 * SignsApi - object-oriented interface
 * @export
 * @class SignsApi
 * @extends {BaseAPI}
 */
export class SignsApi extends BaseAPI {
    /**
     * User can cancel the operation (when they have sufficient permissions).
     * @param {SignsApiCancelV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignsApi
     */
    public cancelV5(requestParameters: SignsApiCancelV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return SignsApiFp(this.configuration).cancelV5(requestParameters.xCorrelationId, requestParameters.operationUuid, requestParameters.operationCancelRequestV5, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign (\"eyes\" or standard). Used for AuthorizationMethod.FIRST_FACTOR
     * @param {SignsApiConfirmV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignsApi
     */
    public confirmV5(requestParameters: SignsApiConfirmV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return SignsApiFp(this.configuration).confirmV5(requestParameters.xCorrelationId, requestParameters.operationUuid, requestParameters.operationConfirmRequestV5, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search four-eyes operations based on filter.
     * @param {SignsApiSearchFourEyesV5Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignsApi
     */
    public searchFourEyesV5(requestParameters: SignsApiSearchFourEyesV5Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return SignsApiFp(this.configuration).searchFourEyesV5(requestParameters.xCorrelationId, requestParameters.fourEyesOperationSearchFilterV5, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


